(function () {
  var TRANSITION_MS = 500;

  function initFaq(section) {
    if (section.dataset.jhpFaqInit === 'true') return;
    section.dataset.jhpFaqInit = 'true';

    var more = section.querySelector('[data-jhp-faq-more]');
    if (!more) return;

    var moreBtn = section.querySelector('[data-jhp-faq-more-btn]');
    var lessBtn = section.querySelector('[data-jhp-faq-less-btn]');

    function setExpanded(expanded) {
      if (expanded) {
        section.classList.remove('is-collapsing');
        section.classList.add('is-expanded');
      } else {
        section.classList.add('is-collapsing');
        section.classList.remove('is-expanded');
        window.setTimeout(function () {
          section.classList.remove('is-collapsing');
        }, TRANSITION_MS);
      }

      if (moreBtn) moreBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (lessBtn) lessBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        setExpanded(true);
      });
    }

    if (lessBtn) {
      lessBtn.addEventListener('click', function () {
        setExpanded(false);
      });
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-jhp-faq]').forEach(initFaq);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
